import React from 'react';
import { exitScreenCSS } from './ExitScreen.css';
import { calculatorBlueArrowLeft, exitScreenElementLeft, exitScreenElementRight, peicarLogo2vector } from '../../../../../Assets/Images';
import { useNavigate } from 'react-router-dom';

function ExitScreen(props) {
    const navigateTo = useNavigate();

    function returnToHome(){
        navigateTo("/");
    }

    return (
        <div css={exitScreenCSS()}>
            <img src={exitScreenElementLeft} className='bgLeftElement bgElement' />
            <img src={exitScreenElementRight} className='bgRightElement bgElement' />
            <div className="CenterDiv">
                <div className="LogoDiv">
                    <img src={peicarLogo2vector} />
                    <div className="Line">

                    </div>
                </div>
                <div className="BlueTextDiv">
                    <span className='XLText font-bold'>¡Cuenta con eso!</span>
                    <span className='LText font-medium'>en breve te contactaremos.</span>
                </div>

                <span className='GreenText MText'>Gracias por elegir a PEICAR.</span>

                <div className="BottomTextDiv" onClick={returnToHome}>
                    <img src={calculatorBlueArrowLeft} />
                    <span>Volver a inicio</span>
                </div>
            </div>
        </div>
    );
}

export {ExitScreen};